<template>
    <div
        v-if="game"
        class="pt-32 pb-12 bg-cover bg-center bg-no-repeat"
        :style="{
            backgroundImage: `url(${require('@/assets/img/gamebackground.jpg')})`
        }"
    >
        <div class="relative w-full max-w-screen-lg mx-auto pt-16">
            <back-button with-text></back-button>

            <div class="game-container mx-auto" :class="gameContainerClasses">
                <iframe
                    ref="gameFrame"
                    class="absolute top-0 left-0 w-full h-full"
                    :src="game.url"
                    allowtransparency="true"
                >
                </iframe>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import BackButton from "../components/BackButton";

export default {
    name: "game",

    components: { BackButton },

    data() {
        return {
            orientation: this.getOrientation()
        };
    },

    async created() {
        if (!this.games.length) {
            this.$store.dispatch("FETCH_GAMES");
        }
    },

    mounted() {
        if (this.$isMobile()) {
            window.addEventListener(
                "resize",
                () => (this.orientation = this.getOrientation())
            );
        }
    },

    computed: {
        ...mapState(["games"]),

        game() {
            return this.games.find(g => g.id == this.$route.params.id);
        },

        gameContainerClasses() {
            if (this.$isMobile() && this.orientation == "landscape") {
                return "fixed top-0 left-0 w-full h-screen z-20";
            }

            return "relative pb-game-ar";
        }
    },

    methods: {
        getOrientation() {
            return window.innerWidth > window.innerHeight
                ? "landscape"
                : "portrait";
        }
    }
};
</script>

<style scoped>
.game-container {
    -webkit-overflow-scrolling: touch;
}
</style>
